export default __webpack_public_path__ + "static/media/sitepen.a2ebf046.png";